<template>
  <v-container fluid class="webproject-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/webproject/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              v-model="item_seleted"
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="webprojects-table"
              show-select
              single-select
              item-key="_id"
              sort-by="createdAt"
              sort-desc
              :footer-props="footer"
              :headers="header_projects"
              :items="webprojects"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteWebProject"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this WebProject?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_webproject.projectcode }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteWebProject = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteWebProject(delete_webproject)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.projectstatus="{ item }">
                <v-chip
                  :color="!item.projectstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.projectstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ new Date(item.updatedAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editWebProject(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'WebProjectList',
  data() {
    return {
      isDeleteWebProject: false,
      isLoading: false,
      delete_webproject: {},
      item_seleted: [],
      header_projects: [
        { text: 'Code', value: 'projectcode'},
        { text: 'Name', value: 'projectname'},
        { text: 'Type', value: 'projecttype'},
        { text: 'Create', value: 'createdAt' },
        { text: 'Update', value: 'updatedAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
    }
  },
  computed: {
    ...mapState('WebProject', ['webprojects', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating']),
  },
  created () {
    this.getWebProjectsRequest()
  },
  methods: {
    ...mapActions('WebProject', ["deleteWebProjectRequest","getWebProjectsRequest","copyWebProjectRequest"]),
    editWebProject(item) {
      this.$router.push({name: 'WebProjectEdit', params: item});
    },
    deleteWebProject(item) {
      this.deleteWebProjectRequest({_id: item._id});
      this.isDeleteWebProject = false;
    },
    deleteDialog(item) {
      this.isDeleteWebProject = true;
      this.delete_webproject = {_id: item._id,projectcode: item.projectcode};
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
